import apiConfig from './getWay';
import env from './env';

let config = {};
if (env.isDev) {
  // 开发环境
  config = apiConfig['dev'];
} else if (env.isSim) {
  // 提测环境
  config = apiConfig['sim'];
} else if (env.isPre) {
  // 预发环境
  config = apiConfig['pre'];
} else if (env.isPro) {
  // 正式环境
  config = apiConfig['online'];
} else {
  config = apiConfig['online'];
}

export default config;
